import React from 'react';
import { Switch as BPSwtich } from '@blueprintjs/core';
import { WithErrorLabel } from '@hobs/components/FormError';
import InputLabel from '@hobs/components/InputLabel';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import objectPath from 'object-path';
import Styles from './Switch.module.scss';

const Switch = ({
  field,
  dark,
  setFieldValue = () => {},
  wrapperClassName,
  label,
  indicationMessage,
  onChange,
  ...props
}) => {
  const handleChange = ({ target }) => {
     setFieldValue(name, target.checked);
     if (onChange){
       onChange(target.checked);
     }
  };

  const name = objectPath.get(field, 'name');

  return (
    <div
      className={classnames(Styles.wrapper, {
        [wrapperClassName]: wrapperClassName
      })}
    >
      <BPSwtich
        {...props}
        {...field}
        onChange={handleChange}
        className={classnames(Styles['switch'], {
          [Styles.dark]: dark,
          [props.className]: props.className
        }, 'stop-drag')}
        labelElement={
          indicationMessage ? (
            <InputLabel indicationMessage={indicationMessage}>
              {label}
            </InputLabel>
          ) : null
        }
        label={indicationMessage ? null : label}
      />
    </div>
  );
};

Switch.propTypes = {
  field: PropTypes.object,
  setFieldValue: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  dark: PropTypes.bool,
  indicationMessage: PropTypes.object,
  onChange: PropTypes.func
};

export default WithErrorLabel(Switch);
